<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='vip_id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :disabled="record.disabled" :ghost="!record.select" v-if='!checkout'>{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :disabled="record.disabled" :ghost="!record.select" v-else>{{record.disabled?'该会员等级不能选择':(!record.select ? "选择":"已选择")}}
      </a-button>
    </template>
  </a-table>
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getMemberVip } from "@/api/member.js";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  export default {
    name: "selectTask",
    components: {},
    props: {
      selectList: {
        type: Array
      },
      disabledList:{
        type:Array
      },
      checkout: {
        type: Boolean
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        selectList: [],
        checkout: false,
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "vip_id",
          key: "vip_id",
        },
        {
          title: "名称",
          dataIndex: "vip_name",
          key: "vip_name",
        },
        {
          title: "成长值",
          dataIndex: "vip_exp",
          key: "vip_exp"
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        }
      ];
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.vip_id == e.vip_id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const initData = async () => {
        state.listLoading = true;
          let res = await getMemberVip().then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            if (state.selectList.length > 0) {
              data.value.forEach(i => {
                if (state.selectList.find(v => i.vip_id == v.vip_id)) {
                  i.select = true
                }
              })
            }
            if (props.disabledList.length > 0) {
              data.value.forEach(i => {
                if (props.disabledList.find(v => i.vip_id == v)) {
                  i.disabled = true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
      };
      onMounted(() => {
        state.selectList = JSON.parse(JSON.stringify(props.selectList))
        initData();
      });
      return {
        ...toRefs(state),
        data,
        columns,
        select,
        checkBnt,
        confirm
      };
    },
  };
</script>
